export default function AdminMenu(props) {

    const style = {

    };

    return (
        <div style={style}>
            <div align="center" style={{height: "80px", fontSize: "36px", paddingTop:"10px"}}>iZeem Admin Panel</div>
            <div align="center" style={{fontSize: "18px", background: "#AAAAAA" }}>
                <table width="100%" height="100%">
                    <tr height="50px">
                        <td width="20%" align="center" style={{ background: "#606060" }}>
                            <a style={{ color: "#FFFFFF" }} href="/izeem-admin/AdminViewDeviceHealth">Device Health Status</a>
                        </td>
                        <td width="20%" align="center" style={{ background: "#3f3f3f" }}>
                            <a style={{color: "#FFFFFF"}} href="/izeem-admin/Register">Register New User</a>
                        </td>
                        <td width="20%" align="center" style={{ background: "#606060" }}>
                            <a style={{color: "#FFFFFF"}} href="/izeem-admin/AdminTaskSchedule">Task Schedule</a>
                        </td>
                        <td width="20%" align="center" style={{ background: "#3f3f3f" }}>
                            <a style={{color: "#FFFFFF"}} href="/izeem-admin/AdminViewData">View Data</a>
                        </td>
                        <td width="20%" align="center" style={{ background: "#606060" }}>
                            <a style={{color: "#FFFFFF"}} href="/izeem-admin/AdminViewDevice">View Device</a>
                        </td>
                    </tr>
                </table>
            </div>
            <div style={{height: "30px"}}></div>
        </div>

    );
}
